import { useStoreState } from 'easy-peasy';

interface Role {
  role: string;
  division: { edittenders: boolean };
}

interface SolutionDivision {
  restrictedaccess?: boolean;
}

export const usePermissions = () => {
  const solution = useStoreState((state) => state.auth.solution);
  const tradeActions = useStoreState((state) => state.auth.userTradeActions);
  const solutionDivisions = useStoreState(
    (state) => state.auth.solutionDivisions
  );
  const solutionSettings = useStoreState(
    (state) => state.auth.solutionSettings
  );

  const canBuy = !!tradeActions?.includes('buy');
  const canSell = !!tradeActions?.includes('sell');

  const roles: Role[] = solution?.roles ?? [];
  const canCreateTender =
    roles.map((r) => r.division.edittenders).includes(true) &&
    (solution?.tenderlogic === 'purchase'
      ? roles.map((r) => r.role).includes('manager')
      : roles.map((r) => r.role).includes('manager') ||
        roles.map((r) => r.role).includes('trader'));

  const divisions: SolutionDivision[] = solutionDivisions ?? [];
  const hasRestrictedAccess = divisions.some((s) => s?.restrictedaccess);

  const isMarketplaceEnabled = !!solutionSettings?.marketplace;

  return {
    canBuy,
    canSell,
    canCreateTender,
    hasRestrictedAccess,
    isMarketplaceEnabled,
  };
};
